export default "__VITE_ASSET__BKHQUtut__"